<dashboardnav>
  
    <cradua-function
    [companies]="companies$ | async"
    [functions]="functions$ | async"
    (changeEmit)="onSubmitFunction($event)"
    (deleteEvent)="onDeleteFunction($event)"
    *ngIf="(isLoading$ | async) === false &&
    (isCompanyLoading$ | async ) === false"
    >
  </cradua-function>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true &&
    (isCompanyLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  